// extracted by mini-css-extract-plugin
module.exports = {"button_container":"OnboardModalFooter_button_container__2nk-5","blue_button":"OnboardModalFooter_blue_button__1vwdU","gray_button":"OnboardModalFooter_gray_button__1sjzD"};